import { render, staticRenderFns } from "./KRouterLink.vue?vue&type=template&id=1643305e&scoped=true&"
import script from "./KRouterLink.vue?vue&type=script&lang=js&"
export * from "./KRouterLink.vue?vue&type=script&lang=js&"
import style0 from "./KRouterLink.vue?vue&type=style&index=0&id=1643305e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1643305e",
  null
  
)

export default component.exports